// extracted by mini-css-extract-plugin
module.exports = {"postMain":"postList-module--postMain--2mSVt","postList":"postList-module--postList--1fqvn"};